<script>
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
import "chartjs-plugin-datalabels";
import "chartjs-plugin-deferred";

export default {
  name: "doughnut-chart",
  mixins: [reactiveProp],
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "bottom"
      },
      tooltips: {
        enabled: true
      },
      plugins: {
        datalabels: {
          color: "#ffffff",
          formatter: value => {
            return `${value}%`;
          },
          labels: {
            title: {
              font: {
                weight: "bold"
              }
            },
            value: {
              font: {
                weight: "bold"
              }
            }
          }
        },
        deferred: {
          xOffset: 150,
          yOffset: "50%",
          delay: 500
        }
      }
    },
    chartStyles: {
      height: `300px`
    }
  }),
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
</script>
